import { useFormValidation, useSnackbarHandler } from "@repo/lib/hooks/common";
import { globalVerifyOTP } from "@repo/server-actions/account";
import { useCallback, useState, useTransition } from "react";

const useForgotPassword = () => {
  const [showVerifyOTP, setShowVerifyOTP] = useState(false);
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [token, setToken] = useState(null);
  const [otpValue, setOtpValue] = useState("");
  const [isPending, startTransition] = useTransition();
  const { formValues, formErrors, setFormErrors, handleValidation } =
    useFormValidation({ email: "" });
  const { showSnackbar } = useSnackbarHandler();

  const handleVerifyOtp = useCallback(
    (e) => {
      e.preventDefault();
      const payLoad = {
        email: formValues?.email,
        otp: otpValue,
      };
      startTransition(async () => {
        const response = await globalVerifyOTP(payLoad);
        showSnackbar(response);
        if (response?.success) {
          setToken(response?.token);
          setShowVerifyOTP(false);
          setShowResetPassword(true);
        }
      });
    },
    [otpValue, formValues?.email, showSnackbar]
  );

  return {
    showVerifyOTP,
    showResetPassword,
    token,
    otpValue,
    setOtpValue,
    formValues,
    formErrors,
    setFormErrors,
    handleValidation,
    isPending,
    handleVerifyOtp,
    setShowVerifyOTP,
  };
};

export default useForgotPassword;
